app.hotel = () => {
  const sharing = document.querySelector('.sharing');
  const twoBeds = document.querySelector('.two-beds');
  const hotelShow = document.querySelector('#occupant_hotel_1');
  const hotelHide = document.querySelector('#occupant_hotel_0');
  const shareShow = document.querySelector('#occupant_share_1');
  const shareHide = document.querySelector('#occupant_share_0');
  const checkIn = document.querySelector('#occupant_check_in');
  const checkOut = document.querySelector('#occupant_check_out');
  const beds = document.querySelector('.two-beds');

  function init() {
    hotelShow.addEventListener('change', showHideShare);
    hotelHide.addEventListener('change', showHideShare);
    shareShow.addEventListener('change', showHideBeds);
    shareHide.addEventListener('change', showHideBeds);
  }

  let showHideShare = event => {
    event.preventDefault();
    showHide(event.currentTarget, sharing);
  };

  let showHideBeds = event => {
    event.preventDefault();
    const target = event.currentTarget;
    showHide(target, twoBeds);
    const roommate = document.querySelector('.roommate');
    if (target.value === '1') {
      roommate.classList.remove('hide');
    } else {
      roommate.classList.add('hide');
      roommate.querySelector('#occupant_roommate').value = null;
    }
  };

  let showHide = (target, div) => {
    if (target.value === '1') {
      div.classList.remove('hide');
    } else {
      div.classList.add('hide');
      div.querySelectorAll('input[type="date"]').forEach(function(el) {
        el.value = null;
      });
      shareHide.checked = true;
      div.querySelector('#occupant_two_beds_0').checked = true;
      if (beds) beds.classList.add('hide');
      const roommate = div.querySelector('#occupant_roommate');
      if (roommate) roommate.value = null;
    }
  };

  return init();
};
